const moment = require('moment');

export const filters = () => {
    return {
        filter: '',
        company_id: null,
        location_id: null,
        location: null,
        select_location: true,
        page: 1,
        per_page: 15
    };
};

export const filtersHazid = () => {
    return {
        filter: '',
        page: 1,
        per_page: 15
    };
};

export const selectedMatrix = () => {
    return {
        date: moment().format('YYYY-MM-DD'),
        slq_company_id: null,
        slq_location_id: null,
        location: null,
        slq_area_id: null,
        area: null,
        select_location: true,
        processes: [],
        user: {},
        company: {},
        location_relation: {}
    };
};

export const process = () => {
    return {
        id: null,
        slq_company_process_id: null,
        activities: [],
        activities_objects: []
    };
};

export const topEvent = () => {
    return {
        consequences: [],
        id: null,
        interpretation: null,
        observations: null,
        interpretation_two: null,
        observations_two: null,
        slq_hazard_identification_process_danger_id: null,
        sys_top_event_list_id: null,
        evaluation: [],
        danger_sources: [],
        second_order_barriers_ids: [],
        second_order_barriers: [],
        third_order_barriers_ids: [],
        third_order_barriers: [],
        top_event: {}
    };
};

export default {
    matrix: {data: []},
    selected_matrix: selectedMatrix(),
    selected_matrix_view: [],
    processes_bow_tie: [],
    filters: filters(),
    filters_hazid: filtersHazid(),
    companies: [],
    processes: [],
    activities: [],
    categories: [],
    top_events: [],
    barriers: [],
    danger_sources: [],
    process: process(),
    top_event: topEvent(),
    companies_filter: [],
    locations: [],
    locations_filter: [],
    action: 'Crear',
    modal: {show: false},
    action_hazid: 'Crear',
    clear_data: false,
    modal_hazid: {show: false},
    modal_bow_tie: {show: false},
    steps: {step: 0}
};
